import React, { useEffect, useState } from "react";
import API_BASE_URL from "../../../config";
import Sidebar from "./Sidebar";
import axios from "axios";
import { useLocation, useNavigate } from "react-router-dom";
import "../../../Styles/Admin/assessment/Quizzes.css";

function formatDate(dateStr) {
  if (!dateStr || dateStr === "NULL") return "";
  const d = new Date(dateStr);
  if (isNaN(d)) return "";
  return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}-${String(d.getDate()).padStart(2, "0")} ${String(d.getHours()).padStart(2, "0")}:${String(d.getMinutes()).padStart(2, "0")}:${String(d.getSeconds()).padStart(2, "0")}`;
}

function getDuration(start, end, fallback) {
  if (start && end && start !== "NULL" && end !== "NULL") {
    const s = new Date(start);
    const e = new Date(end);
    if (!isNaN(s) && !isNaN(e)) {
      const mins = Math.round((e - s) / 60000);
      return `${mins} Mins`;
    }
  }
  return fallback && fallback !== "NULL" ? fallback : "";
}

const AssessmentTaken = () => {
  const [details, setDetails] = useState([]);
  const [search, setSearch] = useState("");
  const [filtered, setFiltered] = useState([]);
  const [shareThoughts, setShareThoughts] = useState([]);
  const location = useLocation();
  const navigate = useNavigate();

  // Get employee_email and company_id from query string
  const params = new URLSearchParams(location.search);
  const employeeEmailParam = params.get("employee_email");
  const companyIdParam = params.get("company_id");

  useEffect(() => {
    fetchDetails();
    // eslint-disable-next-line
  }, [employeeEmailParam]);

  useEffect(() => {
    // Fetch all Share Your Thoughts answers for the selected employee
    if (employeeEmailParam) {
      axios
        .get(`${API_BASE_URL}/api/assessment-answers?employee_email=${encodeURIComponent(employeeEmailParam)}`)
        .then((res) => {
          const allAnswers = res.data.answers || res.data || [];
          const shareAnswers = allAnswers.filter(
            (ans) =>
              ans.question &&
              (
                ans.question.toLowerCase().includes("share your thoughts") ||
                ans.isShareThoughts ||
                ans.question.toLowerCase().includes("what makes you feel valued") ||
                ans.question.toLowerCase().includes("what one thing would you like to see changed")
              )
          );
          setShareThoughts(shareAnswers);
        })
        .catch(() => setShareThoughts([]));
    } else {
      setShareThoughts([]);
    }
  }, [employeeEmailParam]);

  const fetchDetails = async () => {
    try {
      let url = `${API_BASE_URL}/api/assessment-taken`;
      if (employeeEmailParam) {
        url += `?employee_email=${encodeURIComponent(employeeEmailParam)}`;
      }
      const res = await axios.get(url);
      setDetails(res.data);
      setFiltered(res.data);
    } catch (err) {
      setDetails([]);
      setFiltered([]);
    }
  };

  const handleSearch = (e) => {
    const value = e.target.value;
    setSearch(value);
    setFiltered(
      details.filter((d) =>
        d.section && d.section.toLowerCase().includes(value.toLowerCase())
      )
    );
  };

  // Group rows by employee_email (or another unique assessment identifier)
  const grouped = {};
  filtered.forEach((d) => {
    const key = d.employee_email || d.id;
    if (!grouped[key]) grouped[key] = [];
    grouped[key].push(d);
  });
  const groupedList = Object.values(grouped);

  // Debug: Show API data if nothing is rendering
  const debug = (details.length === 0 && shareThoughts.length > 0) ? (
    <div style={{color: 'red', fontSize: 14, marginBottom: 16}}>
      <b>Debug:</b> No assessment details found.<br/>
      <pre style={{whiteSpace: 'pre-wrap', wordBreak: 'break-all', background: '#f8f8f8', padding: 8, borderRadius: 4}}>
        {JSON.stringify(details, null, 2)}
      </pre>
    </div>
  ) : null;

  return (
    <div className="quizzes-container">
      <Sidebar />
      <div className="quizzes-content">
        <div className="quizzes-card">
          {debug}
          <h2 className="quizzes-title">Assessment Details</h2>
          {/* User Info Section */}
          {employeeEmailParam && details.length > 0 && (
            <div style={{ marginBottom: 24 }}>
              <div>
                <strong>Name:</strong> {details[0].employee_name || details[0].name || "-"}
              </div>
              <div>
                <strong>Email:</strong> {details[0].employee_email || details[0].email || "-"}
              </div>
              <div>
                <strong>Company:</strong> {details[0].company_name || details[0].company || "-"}
              </div>
            </div>
          )}
          {!employeeEmailParam && (
            <div className="quizzes-search-row" style={{ gap: 16 }}>
              <input
                type="text"
                placeholder="Search by Section"
                className="quizzes-search-input"
                value={search}
                onChange={handleSearch}
                style={{ width: 220 }}
              />
            </div>
          )}
          <div style={{ overflowX: "auto" }}>
            <table className="quizzes-table">
              <thead>
                <tr>
                  <th>S.NO</th>
                  {/* <th>Employee Email</th> */}
                  <th>Section</th>
                  <th>Start Date</th>
                  <th>Finish Date</th>
                  <th>Duration</th>
                  <th>Success</th>
                  <th>Pass Score</th>
                  <th>Total Score</th>
                  <th style={{ textAlign: "center" }}>View Details</th>
                </tr>
              </thead>
              <tbody>
                {groupedList.length === 0 ? (
                  <tr>
                    <td colSpan={9} style={{ textAlign: "center", padding: 24, color: "#aaa" }}>
                      No assessment details found.
                    </td>
                  </tr>
                ) : (
                  groupedList.map((rows, idx) => (
                    <React.Fragment key={rows[0]?.id || idx}>
                      {/* Show employee details above each group when not filtered by email */}
                      {!employeeEmailParam && rows[0] && (
                        <tr>
                          <td colSpan={9} style={{ background: "#f8f8f8", fontWeight: 500, padding: "12px 8px" }}>
                            <span style={{ marginRight: 24 }}>
                              <strong>Name:</strong> {rows[0].employee_name || rows[0].name || "-"}
                            </span>
                            <span style={{ marginRight: 24 }}>
                              <strong>Email:</strong> {rows[0].employee_email || rows[0].email || "-"}
                            </span>
                            <span>
                              <strong>Company:</strong> {rows[0].company_name || rows[0].company || "-"}
                            </span>
                          </td>
                        </tr>
                      )}
                      {rows.map((d, i) => (
                        <tr key={d.id}>
                          <td>{i === 0 ? idx + 1 : ""}</td>
                          <td>{d.section}</td>
                          <td>{d.assessment_start_date || d.start_date ? formatDate(d.assessment_start_date || d.start_date) : '-'}</td>
                          <td>{d.finish_date ? formatDate(d.finish_date) : '-'}</td>
                          <td>{(d.assessment_start_date || d.start_date) && d.finish_date ? getDuration(d.assessment_start_date || d.start_date, d.finish_date, d.assessment_duration || d.duration) : (d.assessment_duration || d.duration || '-')}</td>
                          <td>{d.success}</td>
                          <td>{d.pass_score}</td>
                          <td>{d.total_score}</td>
                          {i === 0 && (
                            <td
                              rowSpan={rows.length}
                              style={{ textAlign: "center", verticalAlign: "middle" }}
                            >
                              <button
                                className="quizzes-view-details-btn"
                                onClick={() =>
                                  navigate(
                                    `/admin/assessment/view-details?employee_email=${encodeURIComponent(
                                      d.employee_email
                                    )}`
                                  )
                                }
                              >
                                View Details
                              </button>
                            </td>
                          )}
                        </tr>
                      ))}
                    </React.Fragment>
                  ))
                )}
              </tbody>
            </table>
          </div>
          {/* Share Your Thoughts Section for the employee */}
          {employeeEmailParam && (
            <div style={{ marginTop: 32 }}>
              <h3 style={{ marginBottom: 16 }}>Share Your Thoughts Answers</h3>
              {shareThoughts.length > 0 ? (
                <div style={{ marginBottom: 24, background: "#f8f8f8", borderRadius: 8, padding: 16 }}>
                  {shareThoughts.map((ans, i) => (
                    <div key={i} style={{ marginBottom: 18 }}>
                      <div style={{ fontWeight: 500, marginBottom: 6 }}>{ans.question}</div>
                      <textarea
                        value={ans.answer || ""}
                        readOnly
                        rows={4}
                        style={{
                          width: "100%",
                          maxWidth: 500,
                          background: "#f5f5f5",
                          color: "#222",
                          borderRadius: 8,
                          border: "1px solid #d1d5db",
                          padding: "12px",
                          fontSize: "1rem"
                        }}
                      />
                    </div>
                  ))}
                </div>
              ) : (
                <div style={{ color: "#888", marginBottom: 16 }}>No Share Your Thoughts answers found.</div>
              )}
            </div>
          )}
          {/* Back Button */}
          <button
            className="quizzes-view-details-btn"
            style={{ marginTop: 18 }}
            onClick={() => {
              if (companyIdParam) {
                navigate(`/admin/assessment/employees?company_id=${encodeURIComponent(companyIdParam)}`);
              } else {
                navigate(-1);
              }
            }}
          >
            Back
          </button>
        </div>
      </div>
    </div>
  );
};

export default AssessmentTaken;